import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass'],

})
export class FooterComponent implements OnInit {

  @Input() next: string;
  @Input() prev: string;
  @Input() prevEvent: boolean = false;
  @Input() nextEvent: boolean = false;
  @Input() prevText: string;

  @Output() clickNext = new EventEmitter<string>();
  @Output() clickPrev = new EventEmitter<string>();

  constructor(private location: Location) { }

  ngOnInit() {
  }

  onPrevClick(prev: string) {
    this.location.back();
  }

  onNextClick(next: string) {
    this.clickNext.emit(next);
  }

}
